import React, { useState, useEffect, useContext } from 'react';
import { Typography, Box, Card, CardContent, List, ListItem, ListItemText, Divider, Button } from '@mui/material';
import RoomTypeRatePlanContext from '../contexts/RoomTypeRatePlanContext';
import { format } from 'date-fns';
import jsPDF from 'jspdf';
import {obtenerImagenCabezal, obtenerDatosHotel} from '../../services/motorService';
import Cookies from 'js-cookie';
const ReservationSummary = () => {
    const { cartItems, reservaAdmintour } = useContext(RoomTypeRatePlanContext);
    const [bannerUrl, setBannerUrl] = useState(null);
    const hotCod = Cookies.get('hotCod');
    const [datosHotel, setDatosHotel] = useState({});
    useEffect(() => {

        const fetchBannerImage = async () => {
          try {
            const imagenBase64 = await obtenerImagenCabezal(hotCod);
            if(!imagenBase64.startsWith('Imagen del Cabezal Sin Datos para el hotel')){
                setBannerUrl(`data:image/png;base64,${imagenBase64}`);
            }
          } catch (error) {
            console.error('Error fetching header image:', error);
          }
        };
    
        fetchBannerImage();
      }, []);

    const formatTitleDate = () => {
        if (cartItems && cartItems.length > 0) {
            const checkinDate = new Date(cartItems[0].CarritoItemDesde);
            const checkoutDate = new Date(cartItems[0].CarritoItemHasta);
        
            const checkinDay = checkinDate.getUTCDate();
            const checkinMonth = checkinDate.getUTCMonth() + 1;
            const checkinYear = checkinDate.getUTCFullYear();
            const fullcheckinData = checkinDay + "/" + checkinMonth + "/" + checkinYear;
        
            const checkoutDay = checkoutDate.getUTCDate();
            const checkoutMonth = checkoutDate.getUTCMonth() + 1;
            const checkoutYear = checkoutDate.getUTCFullYear();
            const fullcheckoutData = checkoutDay + "/" + checkoutMonth + "/" + checkoutYear;
        
            return "Reserva para el período " + fullcheckinData + " - " + fullcheckoutData + "RESERVA ADMINTOUR: " + reservaAdmintour;
        }
        return "";
    };

    const totalImporte = cartItems
        ? cartItems.reduce((total, item) => total + parseFloat(item.CarritoItemTotal || 0), 0)
        : 0;

    const obtengoCarritoMoneda = (carrito) => {
        if (carrito && carrito.length > 0) {
            return carrito[0].CarritoItemMoneda;
        }
        return "";
    };
    const getData = async () => {
        try {
            const data = await obtenerDatosHotel(hotCod); // Usa hotCod en la llamada a la API
            setDatosHotel(data);
        } catch (error) {
            console.error('Error fetching hotel data:', error);
        }
    };
    getData();
    const generatePDF = async () => {
        const doc = new jsPDF();
        const pageHeight = doc.internal.pageSize.height; // Altura de la página
        // Añadir la imagen en el encabezado (posición x=10, y=10, ancho=50, alto=20)
        doc.addImage(bannerUrl, 'JPEG',  0, 10, 210, 40);
        let y = 60; // Ajustamos la posición después de la imagen
        // Título
        doc.setFontSize(18);
        doc.setFont("helvetica", "bold"); 
        const nombreCarta = datosHotel.TituloCarta
        doc.text(nombreCarta, 20, y);
        doc.setFont("helvetica", "normal");
        y += 10;
    
        // Texto introductorio ajustado al ancho
        doc.setFontSize(12);
        const introText = datosHotel.MotorHotTextoConf;
        const splitIntroText = doc.splitTextToSize(introText, 180);
        splitIntroText.forEach((line) => {
            if (y > pageHeight - 20) { // Verificar si se necesita un salto de página
                doc.addPage();
                y = 20; // Reiniciar `y` para la nueva página
            }
            doc.text(line, 20, y);
            y += 6;
        });
        y += 10;
        // Detalle de las habitaciones
        doc.setFont("helvetica", "bold"); 
        doc.text(`Detalle de habitaciones reservadas para la reserva número  ${reservaAdmintour}`, 20, y);
        doc.setFont("helvetica", "normal");

        // Desglose del detalle de habitaciones
        for (const item of cartItems) {
            //handleChartDetail(item.CarritoItemLinea);
            //const detail = await obtenerDetalleCarrito(hotCod, session, item.CarritoItemLinea);
            //console.log("DETAIL:", detail);
            y += 10;
            if (y > pageHeight - 20) {
                doc.addPage();
                y = 20;
            }
            doc.setFont("helvetica", "bold");
            doc.text(`Período de la reserva de la habitación ${item.CarritoItemLinea}:`, 20, y);
            doc.setFont("helvetica", "normal");
            y += 10;
            doc.text(`Check-in: ${item.CarritoItemDesde}`, 20, y);
            doc.text(`Check-out: ${item.CarritoItemHasta}`, 120, y); // Alineado en dos columnas
            y += 10;
            doc.text(`Tipo de Habitación: ${item.CarritoItemTipoHab}`, 20, y);
            y += 10;
            doc.text(`Tarifa contratada: ${item.CarritoItemTarifa}`, 20, y);
            doc.text(`Adultos: ${item.CarritoItemMayores}, Menores: ${item.CarritoItemMenores}`, 120, y);
            y += 10;
            if (y > pageHeight - 20) {
                doc.addPage();
                y = 20;
            }
            //console.log("DETAIL:", detail);
            //console.log("RATEDETAIL A VER FUNCIONA:", rateDetail);

            /*rateDetail?.forEach((item2, index2)=> {
                doc.text(`${item2.CarritoItemFecha}`, 20, y); // Columna de fechas
                doc.text(`${item.CarritoItemMoneda} ${item2.CarritoItemTotal}`, 120, y); // Columna de precios
                y += 10;
            })
            */
            doc.text(`Total de la habitación: ${item.CarritoItemMoneda} ${item.CarritoItemTotal}`, 20, y);
            y += 10;
        }
        if (y > pageHeight - 20) {
            doc.addPage();
            y = 20;
        }
        y += 10;
        // Total de la estadía
        doc.setFont("helvetica", "bold");
        doc.text(`Total de la estadía: ${totalImporte.toFixed(2)} ${obtengoCarritoMoneda(cartItems)}`, 20, y);
        doc.setFont("helvetica", "normal");
        y += 20;
    
        // Condiciones de compra
        if (y > pageHeight - 20) {
            doc.addPage();
            y = 20;
        }
        doc.setFont("helvetica", "bold");
        doc.text("Condiciones de compra:", 20, y);
        doc.setFont("helvetica", "normal");
        y += 10;
        const condicionesText = datosHotel.Condiciones;
        const splitCondicionesText = doc.splitTextToSize(condicionesText, 180);
        splitCondicionesText.forEach((line) => {
            if (y > pageHeight - 20) {
                doc.addPage();
                y = 20;
            }
            doc.text(line, 20, y);
            y += 6;
        });
        y += 10;


        // Normas del Hotel
        if (y > pageHeight - 30) {
            doc.addPage();
            y = 20;
        }
        doc.setFont("helvetica", "bold");
        doc.text("Normas del Hotel:", 20, y);
        doc.setFont("helvetica", "normal");
        y += 10;
        const normasText = datosHotel.MotorHotNormas;
        const splitNormasText = doc.splitTextToSize(normasText, 180);
        splitNormasText.forEach((line) => {
            if (y > pageHeight - 20) {
                doc.addPage();
                y = 20;
            }
            doc.text(line, 20, y);
            y += 6;
        });
        y += 10;

        // Información del hotel
        if (y > pageHeight - 20) {
            doc.addPage();
            y = 20;
        }
        doc.setFont("helvetica", "bold");
        doc.text("Información del hotel:", 20, y);
        doc.setFont("helvetica", "normal");
        y += 10;
        doc.text(`Teléfono: ${datosHotel.Contacto}`, 20, y);
        doc.text(`Email: ${datosHotel.MotorHotCorreo}`, 20, y + 10);
        doc.text(`Horario de atención: ${datosHotel.MotorHotHorario}`, 20, y + 20);
            
            // Guardar el PDF
        doc.save('confirmacion-reserva.pdf');
    };

    return (
        <Card sx={{ mt: 5}}>
            <CardContent>
                <Typography variant="h5" gutterBottom>
                    Gracias por reservar con nosotros
                </Typography>
                <Typography variant="body1">
                    A continuación le presentaremos el resumen de su reserva
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" color="textSecondary">
                    {formatTitleDate()}
                </Typography>
                <Divider sx={{ my: 2 }} />
                <List>
                    {cartItems.map((item) => (
                        <div key={item.CarritoItemLinea}>
                            <ListItem alignItems="flex-start">
                                <ListItemText
                                    primary={
                                        <>
                                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                {item.CarritoItemTipoHab}
                                            </Typography>
                                            <Typography variant="body1">
                                                {item.CarritoItemTarifa}
                                            </Typography>
                                        </>
                                    }
                                    secondary={
                                        <>
                                            <Typography component="div" color="textSecondary" sx={{ marginTop: 2 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Typography variant="body2" color="textSecondary">
                                                        {`${item.CarritoItemMayores} adulto(s), ${item.CarritoItemMenores} menor(es)`}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        {`${item.CarritoItemTotal} ${item.CarritoItemMoneda}`}
                                                    </Typography>
                                                </Box>
                                            </Typography>
                                        </>
                                    }
                                />
                            </ListItem>
                            <Divider />
                        </div>
                    ))}
                    <Typography component="div" sx={{ marginTop: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                Total
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                {totalImporte.toFixed(2)} {obtengoCarritoMoneda(cartItems)}
                            </Typography>
                        </Box>
                    </Typography>
                </List>
                <Button variant="contained" color="primary" onClick={generatePDF}>
                    Descargar confirmación en PDF
                </Button>
            </CardContent>
        </Card>
    );
};

export default ReservationSummary;
